import { createRouter, createWebHistory } from 'vue-router'
import { getAuthState, canAccessRoute, defaultHomeForRole } from '../utils/auth'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home.vue')
  },
  {
    path: '/compte',
    name: 'Compte',
    component: () => import('../views/Compte.vue')
  },
  {
    path: '/documentation',
    name: 'Documentation',
    component: () => import('../views/Documentation.vue')
  },
  {
    path: '/documentation/request',
    name: 'DocumentationRequest',
    component: () => import('../views/DocumentationRequest.vue')
  },
  {
    path: '/documentation/results',
    name: 'DocumentationResults',
    component: () => import('../views/DocumentationResults.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/reset-password/:token',
    name: 'ResetPassword',
    component: () => import('../views/ResetPassword.vue')
  },
  {
    path: '/services',
    name: 'Services',
    component: () => import('../views/Services.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: () => import('../views/admin/Dashboard.vue')
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: () => import('../views/admin/Users.vue')
  },
  {
    path: '/admin/manage-users',
    name: 'ManageUsers',
    component: () => import('../views/admin/ManageUsers.vue')
  },
  {
    path: '/admin/documents',
    name: 'AdminDocuments',
    component: () => import('../views/admin/Documents.vue')
  },
  {
    path: '/admin/documents-list',
    name: 'DocumentsList',
    component: () => import('../views/admin/DocumentsList.vue')
  },
  {
    path: '/admin/document-requests',
    name: 'AdminDocumentRequests',
    component: () => import('../views/admin/DocumentRequests.vue')
  },
  {
    path: '/admin/partners',
    name: 'AdminPartners',
    component: () => import('../views/admin/Partners.vue')
  },
  {
    path: '/uploader/dashboard',
    name: 'UploaderDashboard',
    component: () => import('../views/uploader/Dashboard.vue')
  },
  {
    path: '/uploader/document-requests',
    name: 'UploaderDocumentRequests',
    component: () => import('../views/uploader/DocumentRequests.vue')
  },
  {
    path: '/uploader/documents',
    name: 'UploaderDocuments',
    component: () => import('../views/uploader/Documents.vue')
  },
  {
    path: '/uploader/documents-list',
    name: 'UploaderDocumentsList',
    component: () => import('../views/uploader/DocumentsList.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  const needsAdmin = to.path.startsWith('/admin')
  const needsUploader = to.path.startsWith('/uploader')
  if (!needsAdmin && !needsUploader) return true

  const { isAuthenticated, role } = getAuthState()

  if (!isAuthenticated) {
    return {
      path: '/',
      query: { redirect: to.fullPath }
    }
  }

  if (!canAccessRoute(to.path, role)) {
    return defaultHomeForRole(role)
  }

  return true
})

export default router
